export default "__VITE_ASSET__DA0_WXpG__"